import { Layout as AntLayout } from 'antd';
import React, { createContext, type ReactNode, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { EnvironmentIndicator } from '../components/environment-indicator';
import { ExtraContentContextProvider } from '../contexts/extra-content-context-provider';
import Header from './header';
import Sider from './sider';

export const SiderContext = createContext<{
  setSiderCollapsed: React.Dispatch<boolean>;
  toggleSiderCollapsed: () => void;
}>({ setSiderCollapsed: () => {}, toggleSiderCollapsed: () => {} });

export const BreadcrumbParamsContext = createContext<{
  breadcrumbParams: Record<string, string>;
  setBreadcrumbParams: React.Dispatch<Record<string, string>>;
}>({ breadcrumbParams: {}, setBreadcrumbParams: () => {} });

const Layout = (): ReactNode => {
  const [breadcrumbParams, setBreadcrumbParams] = useState<Record<string, string>>({});
  const [isSiderCollapsed, setSiderCollapsed] = useState(false);
  return (
    <AntLayout style={{ height: '100vh', overflow: 'hidden' }}>
      <Sider
        isSiderCollapsed={isSiderCollapsed}
        onSiderCollapseChange={(value) => {
          setSiderCollapsed(value);
        }}
      />
      <SiderContext.Provider
        value={{
          setSiderCollapsed,
          toggleSiderCollapsed: () => {
            setSiderCollapsed(!isSiderCollapsed);
          },
        }}
      >
        <BreadcrumbParamsContext.Provider
          value={{
            setBreadcrumbParams,
            breadcrumbParams,
          }}
        >
          <AntLayout>
            <Header />
            <AntLayout.Content
              style={{ overflowX: 'auto', paddingBlockEnd: 36, position: 'relative' }}
            >
              <ExtraContentContextProvider>
                <Outlet />
              </ExtraContentContextProvider>
              <EnvironmentIndicator />
            </AntLayout.Content>
          </AntLayout>
        </BreadcrumbParamsContext.Provider>
      </SiderContext.Provider>
    </AntLayout>
  );
};

export default Layout;
